var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52952 10C8.20951 10 7.90333 9.8697 7.68157 9.63882L0.328577 1.992C-0.122015 1.52377 -0.107309 0.778761 0.361224 0.328463C0.829462 -0.121834 1.57417 -0.107422 2.02447 0.361111L8.52952 7.12616L15.0346 0.361111C15.4846 -0.107128 16.2293 -0.121834 16.6978 0.328463C17.1663 0.778761 17.181 1.52377 16.7305 1.992L9.37746 9.63882C9.1557 9.8697 8.84952 10 8.52952 10Z",
    fill: "url(#paint0_linear_16_2252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_2252",
    x1: 0,
    y1: 5,
    x2: 17.059,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA40F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E80DC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOpen);
export default __webpack_public_path__ + "static/media/more_open.46052a5fc10176a4a37a2b4cfbbe54c7.svg";
export { ForwardRef as ReactComponent };